import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

const GetSingleUser = async (uid) => {
  try {
    const userDocument = await doc(db, "users", uid);

    const userSnapshot = await getDoc(userDocument);

    const user = { id: userSnapshot.id, ...userSnapshot.data() };

    return user;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleUser;
